import { render, staticRenderFns } from "./UserPracticeAreas.vue?vue&type=template&id=07222053&"
import script from "./UserPracticeAreas.vue?vue&type=script&lang=js&"
export * from "./UserPracticeAreas.vue?vue&type=script&lang=js&"
import style0 from "./UserPracticeAreas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports